// extracted by mini-css-extract-plugin
export var blue = "_2d-g";
export var brand = "_2d-c";
export var darkGrey = "_2d-f";
export var disabled = "_2d-6";
export var disabledSubtle = "_2d-7";
export var error = "_2d-8";
export var green = "_2d-h";
export var grey = "_2d-e";
export var icon = "_2d-0";
export var inherit = "_2d-b";
export var lightGrey = "_2d-d";
export var orange = "_2d-j";
export var pink = "_2d-l";
export var primary = "_2d-1";
export var purple = "_2d-m";
export var quaternary = "_2d-4";
export var quinary = "_2d-5";
export var red = "_2d-k";
export var secondary = "_2d-2";
export var success = "_2d-a";
export var tertiary = "_2d-3";
export var warning = "_2d-9";
export var white = "_2d-n";
export var yellow = "_2d-i";